import { Box, Button, CircularProgress } from '@mui/material';

interface CampaignActionButtonsProps {
  onCancel: () => void;
  onSaveAndActivate: () => void;
  isLoading?: boolean;
  isEditMode?: boolean;
}

const CampaignActionButtons = ({
  onCancel,
  onSaveAndActivate,
  isLoading = false,
  isEditMode = false
}: CampaignActionButtonsProps) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: { xs: 'column', sm: 'row' },
        justifyContent: 'flex-end',
        alignItems: 'center',
        gap: 2,
        pt: 2,
        borderTop: '1px solid #E5E7EB'
      }}
    >
      <Button
        variant="text"
        onClick={onCancel}
        disabled={isLoading}
        sx={{
          width: { xs: '100%', sm: 'auto' },
          minWidth: 84,
          height: 44,
          color: '#6B7280',
          fontWeight: 600,
          fontSize: '0.875rem',
          textTransform: 'none',
          '&:hover': {
            backgroundColor: '#F3F4F6'
          }
        }}
      >
        Cancel
      </Button>
      
      <Button
        variant="contained"
        onClick={onSaveAndActivate}
        disabled={isLoading}
        startIcon={isLoading ? <CircularProgress size={20} color="inherit" /> : null}
        sx={{
          width: { xs: '100%', sm: 'auto' },
          minWidth: 84,
          height: 44,
          backgroundColor: '#4F46E5',
          fontWeight: 600,
          fontSize: '0.875rem',
          textTransform: 'none',
          borderRadius: '8px',
          boxShadow: 'none',
          '&:hover': {
            backgroundColor: '#4338CA',
            boxShadow: 'none'
          },
          '&:disabled': {
            backgroundColor: '#9CA3AF',
            color: '#FFFFFF'
          }
        }}
      >
        {isLoading ? (isEditMode ? 'Updating...' : 'Saving...') : (isEditMode ? 'Update Campaign' : 'Save and Proceed')}
      </Button>
    </Box>
  );
};

export default CampaignActionButtons;

